import React, { useState, useEffect } from "react";

import { saveAs } from "file-saver";
import getOrders from "../../api/statistic/getOrders";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton,
  Paper,
  Button,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const StatementReportCard = ({ data }) => {
  return (
    <Grid container spacing={2} sx={{ marginTop: 1 }}>
      <Grid item xs={1}>
        <Typography>{data.OrderId}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.TableName}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.ReservationStartTime}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.ReservationEndTime}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.Price}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.PaymentStatus}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.PaymentMethod}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.Status}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.Discount}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.Total}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.BonusTime}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography>{data.Points}</Typography>
      </Grid>
    </Grid>
  );
};

const formatDateTime = (dateTimeStr) => {
  const date = new Date(dateTimeStr);
  return date.toLocaleString("zh-TW", { timeZone: "Asia/Taipei" }); // 'Asia/Shanghai' is one of the timezones representing GMT+8
};

// Function to convert data to CSV format
const convertToCSV = (objArray) => {
  const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  let str = "";

  // Extract headers
  const headerLine = Object.keys(array[0]).join(",");
  str += headerLine + "\r\n";

  // Extract data rows
  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (const index in array[i]) {
      if (line !== "") line += ",";

      line += array[i][index];
    }
    str += line + "\r\n";
  }

  return str;
};

// Function to trigger download
const downloadCSV = (data, filename) => {
  const csvData = new Blob([convertToCSV(data)], {
    type: "text/csv;charset=utf-8;",
  });
  saveAs(csvData, filename);
};
function OrderReport({ show = false, storeCode, startDate, endDate }) {
  const [orderReport, setOrderReport] = useState([]);
  const [error, setError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleDownloadStatement = () => {
    downloadCSV(orderReport, "orders.csv");
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        let orderData = await getOrders(storeCode, startDate, endDate);
        orderData?.orders.forEach(order => {
          order.ReservationStartTime = formatDateTime(order.ReservationStartTime);
          order.ReservationEndTime = formatDateTime(order.ReservationEndTime);
        });

        setOrderReport(orderData?.orders || []);

        setShowAlert(true);
        setIsSuccess(true);
      } catch (err) {
        setShowAlert(true);
        setIsSuccess(false);
        setError(err.message);
      }
    };

    if (show) {
      fetchData();
    }
  }, [show, storeCode, startDate, endDate]);

  return (
    <>
      <Card sx={{ margin: "1px", marginTop: 1 }}>
        <CardContent>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignContent={"center"}
          >
            <Typography variant="h5" sx={{ marginBottom: 2 }}>
              訂單明細表
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleDownloadStatement}
              sx={{ height: 40 }}
            >
              下載訂單明細表
            </Button>
          </Stack>
          <Grid container spacing={1}>
            {/* Adjusted column headers to match the data fields */}
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>訂單編號</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>桌次名稱</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>預約開始時間</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>預約結束時間</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>價格</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>付款狀態</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>付款方式</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>訂單狀態</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>折扣</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>總計</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>贈送時數</strong>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1">
                <strong>點數</strong>
              </Typography>
            </Grid>
          </Grid>

          {orderReport?.map((report, index) => (

            <StatementReportCard key={index} data={report} />
          ))}
        </CardContent>
      </Card>
    </>
  );
}

export default OrderReport;
